import { type useInvitedUsers } from 'app/network/user';

export type InvitedUsers = NonNullable<ReturnType<typeof useInvitedUsers>['data']>;

export function getReferralProgramState({
  referralPrize202506Available,
  referralPrizeAvailable,
  userWonReferralPrize,
  userWonReferralPrize202506,
}: {
  referralPrize202506Available?: boolean;
  referralPrizeAvailable?: boolean;
  userWonReferralPrize?: boolean;
  userWonReferralPrize202506?: boolean;
}) {
  const tPrefix =
    referralPrizeAvailable || userWonReferralPrize
      ? 'referralProgram.'
      : referralPrize202506Available || userWonReferralPrize202506
        ? 'referralProgram202506.'
        : '';
  return {
    isReferralProgram: tPrefix === 'referralProgram.',
    isReferralProgram202506: tPrefix === 'referralProgram202506.',
    tPrefix,
    tSuffix: userWonReferralPrize || userWonReferralPrize202506 ? 'Won' : '',
  };
}
